module.exports = __webpack_public_path__ + "static/media/team_16_white.bd3bfdd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/team_16_white.svg
// module id = 1399
// module chunks = 0